import { render, staticRenderFns } from "./PRichText.vue?vue&type=template&id=cc9f75ba"
import script from "./PRichText.vue?vue&type=script&lang=js"
export * from "./PRichText.vue?vue&type=script&lang=js"
import style0 from "./PRichText.vue?vue&type=style&index=0&id=cc9f75ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports